import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const SUPPORT_EMAIL = 'brandy@just-B-coaching.com';

export default axios;
